var a = navigator.userAgent.toLowerCase();
let config={
    ipad: /ipad/.test(a),
    iphone: /iphone/.test(a),
    android: /android/.test(a),
    weixin: /micromessenger/.test(a),
    isQQApp:a.match(/QQ/i) == "qq",
    iosScheme:"wssyxj://edujia.com/",
    androidPackageName: "com.dingYZ.dingyzwater",
    downloadUrl: "http://www.edujia.com/",
    aesKey:'0a02040602050504',

};
export default config
